import { Register } from '../../containers/WebApp/Register/Register';

export default Register

export const query = graphql`
query RegisterQuery($language: String!) {
  locales: allLocale(filter: {ns: {in: ["common"]}, language: {eq: $language}}) {
    edges {
      node {
        ns
        data
        language
      }
    }
  }
}
`;

